export const name = "ASCII";
export const summary = `Gets the ASCII code for the first character or byte in a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## ASCII

Gets the ASCII code for the first character or byte in a \`STRING\` or \`BYTES\` value.

\`\`\`
ASCII(value)
\`\`\`

### Description

Returns the ASCII code for the first character or byte in \`value\`. Returns\`0\` if \`value\` is empty or the ASCII code is \`0\` for the first character or byte.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT ASCII('abcd') as A, ASCII('a') as B, ASCII('') as C, ASCII(NULL) as D;

/*-------+-------+-------+-------*
 | A | B | C | D |
 +-------+-------+-------+-------+
 | 97 | 97 | 0 | NULL |
 *-------+-------+-------+-------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
